import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, inject, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { AccountFacade } from 'ish-core/facades/account.facade';
import { Basket } from 'ish-core/models/basket/basket.model';
import { Customer } from 'ish-core/models/customer/customer.model';
import { Order } from 'ish-core/models/order/order.model';
import { whenTruthy } from 'ish-core/utils/operators';

@Component({
  selector: 'ish-basket-buyer',
  templateUrl: './basket-buyer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, FaIconComponent, TranslateModule],
})
export class BasketBuyerComponent implements OnInit {
  private accountFacade = inject(AccountFacade);

  readonly object = input.required<Basket | Order>(); //DIAS-CUSTOMIZATION
  /**
   * Router link for editing the order reference id. If a routerLink is given a link is displayed to route to an edit page.
   */
  readonly editRouterLink = input<string>(undefined);

  private customer$: Observable<Customer>;

  taxationID: string;
  costCenterName: string;
  companyName1: string;
  companyName2: string;

  private destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.taxationID = this.object().taxationId;
    this.costCenterName = this.getAttributeValue('BusinessObjectAttributes#Order_CostCenter_Name');

    const object = this.object();
    this.companyName1 = object.user?.companyName || object.invoiceToAddress?.companyName1 || '';
    const objectValue = this.object();
    this.companyName2 =
      (objectValue.user?.companyName ? objectValue.user?.companyName2 : objectValue.invoiceToAddress?.companyName2) ||
      '';

    this.customer$ = this.accountFacade.customer$;

    // values for registered users and basket
    this.customer$.pipe(whenTruthy(), first(), takeUntilDestroyed(this.destroyRef)).subscribe(customer => {
      this.taxationID = this.taxationID || customer?.taxationID;
    });
  }

  private getAttributeValue(attributeName: string): string {
    return this.object().attributes?.find(attr => attr.name === attributeName)?.value as string;
  }

  get userName(): string {
    const object = this.object();
    return object.user
      ? `${object.user?.firstName} ${object.user?.lastName}`
      : `${object.invoiceToAddress?.firstName} ${object.invoiceToAddress?.lastName}`;
  }
}
